import { render, staticRenderFns } from "./RequestRxTest.vue?vue&type=template&id=5c37a214"
import script from "./RequestRxTest.vue?vue&type=script&lang=js"
export * from "./RequestRxTest.vue?vue&type=script&lang=js"
import style0 from "./RequestRxTest.vue?vue&type=style&index=0&id=5c37a214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports